// 유틸리티 함수들
class Utils {
  // 랜덤 숫자 생성 (min 이상 max 이하)
  static randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  // 배열에서 랜덤 요소 선택
  static randomChoice(array) {
    return array[Math.floor(Math.random() * array.length)];
  }

  // 두 점 사이의 거리 계산
  static distance(pos1, pos2) {
    const dx = pos1.x - pos2.x;
    const dz = pos1.z - pos2.z;
    return Math.sqrt(dx * dx + dz * dz);
  }

  // 랜덤 정수 생성 (min 이상 max 이하)
  static randomIntBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // 디버그 로그 (환경에 따라 출력 제어)
  static log(message, level = "info") {
    // 한국어 주석: 화면 로그는 항상 표시하도록 변경 (개발자 도구 없이도 확인 가능)
    // 콘솔 로그는 디버그 모드에 따라 출력 제어 (에러는 항상 출력)
    // GameConfig가 아직 로드되지 않았을 수 있으므로 안전하게 처리
    const debugEnabled =
      typeof GameConfig !== "undefined" &&
      GameConfig.DEBUG &&
      GameConfig.DEBUG.ENABLED;
    const shouldLogToConsole = debugEnabled || level === "error";

    const prefix =
      level === "warn" ? "[WARN]" : level === "error" ? "[ERROR]" : "[INFO]";

    // 콘솔 로그 출력 (조건부)
    if (shouldLogToConsole) {
      switch (level) {
        case "warn":
          console.warn(`${prefix} ${message}`);
          break;
        case "error":
          console.error(`${prefix} ${message}`);
          break;
        default:
          console.log(`${prefix} ${message}`);
      }
    }

    // 화면에 로그 표시 (토글 가능)
    const uiLogEnabled =
      typeof GameConfig !== "undefined" &&
      GameConfig.DEBUG &&
      GameConfig.DEBUG.UI_LOG_ENABLED === true;
    if (uiLogEnabled) {
      Utils.displayLogOnScreen(message, level);
    }
  }

  // 화면에 로그 표시
  static displayLogOnScreen(message, level = "info") {
    const logContainer = document.getElementById("debugLogContainer");
    if (!logContainer) return;

    // 로그 아이템 생성
    const logItem = document.createElement("div");
    logItem.className = `debug-log-item ${level}`;

    const timestamp = new Date().toLocaleTimeString();
    const prefix =
      level === "warn" ? "[WARN]" : level === "error" ? "[ERROR]" : "[INFO]";
    logItem.textContent = `${timestamp} ${prefix} ${message}`;

    // 컨테이너에 추가
    logContainer.appendChild(logItem);

    // 스크롤을 최하단으로 이동
    logContainer.scrollTop = logContainer.scrollHeight;

    // 최대 100개의 로그만 유지 (메모리 절약)
    while (logContainer.children.length > 100) {
      logContainer.removeChild(logContainer.firstChild);
    }
  }

  // 성능 측정을 위한 간단한 타이머
  static createTimer() {
    const start = performance.now();
    return {
      elapsed: () => performance.now() - start,
      log: (label) =>
        console.log(`${label}: ${(performance.now() - start).toFixed(2)}ms`),
    };
  }

  // 객체 깊은 복사
  static deepClone(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (obj instanceof Date) return new Date(obj.getTime());
    if (obj instanceof Array) return obj.map((item) => Utils.deepClone(item));

    const cloned = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        cloned[key] = Utils.deepClone(obj[key]);
      }
    }
    return cloned;
  }
}

// 전역 변수로 등록 (개별 스크립트 로드 시에도 접근 가능하도록)
window.Utils = Utils;

// webpack 빌드를 위해 default export 추가
export default Utils;

// 로드 확인 로그
try {
  const uiLogEnabled =
    typeof GameConfig !== "undefined" &&
    GameConfig.DEBUG &&
    GameConfig.DEBUG.UI_LOG_ENABLED === true;
  if (uiLogEnabled && typeof window.simpleLog === "function") {
    window.simpleLog("Utils.js 로드 완료 및 전역 등록 완료", "info");
  }
} catch (_) {}
